<template>
  <a-card
    class="card"
    v-if="
      enableCreditTrends ||
        enableTotalAr ||
        enableCreditTrendsMy ||
        enableTotalArMy ||
        enableCreditTrendsBu ||
        enableTotalArBu
    "
  >
    <a-tabs
      :default-active-key="activeKey"
      @change="handleTabChange"
      size="large"
    >
      <a-tab-pane key="1" tab="信用趋势(整体)" v-if="enableCreditTrends">
        <LineChart :dataSource="lineChartData" v-if="lineChartData" />
        <a-skeleton active v-else />
      </a-tab-pane>
      <a-tab-pane key="2" tab="Total AR(整体)" v-if="enableTotalAr">
        <PieChart :dataSource="pieChartData" v-if="pieChartData" />
        <a-skeleton active v-else />
      </a-tab-pane>
      <a-tab-pane key="3" tab="信用趋势(我名下的)" v-if="enableCreditTrendsMy">
        <LineChart :dataSource="lineChartData" v-if="lineChartData" />
        <a-skeleton active v-else />
      </a-tab-pane>
      <a-tab-pane key="4" tab="Total AR(我名下的)" v-if="enableTotalArMy">
        <PieChart :dataSource="pieChartData" v-if="pieChartData" />
        <a-skeleton active v-else />
      </a-tab-pane>
      <a-tab-pane key="5" tab="信用趋势(重点业务)" v-if="enableCreditTrendsBu">
        <LineChart :dataSource="lineChartData" v-if="lineChartData" />
        <a-skeleton active v-else />
      </a-tab-pane>
      <a-tab-pane key="6" tab="Total AR(重点业务)" v-if="enableTotalArBu">
        <PieChart :dataSource="pieChartData" v-if="pieChartData" />
        <a-skeleton active v-else />
      </a-tab-pane>
      <div
        slot="tabBarExtraContent"
        class="chart-date-range"
        v-if="
          (activeKey === '1' && enableCreditTrends) ||
            (activeKey === '3' && enableCreditTrendsMy) ||
            (activeKey === '5' && enableCreditTrendsBu)
        "
      >
        <span style="font-size:16px;">时间：</span>
        <a-range-picker
          @change="handleDateRangeChange"
          :defaultValue="dateRange"
          style="margin-right: 20px;"
        ></a-range-picker>
      </div>
      <div
        slot="tabBarExtraContent"
        class="chart-date-range"
        v-if="
          (activeKey === '5' && enableTotalAr) ||
            (activeKey === '6' && enableCreditTrendsBu)
        "
      >
        <span style="font-size:16px;">业务类型：</span>
        <a-select
          style="width:300px;margin-right: 20px;"
          @change="handleChangeBus"
          allowClear
          option-filter-prop="children"
        >
          <a-select-option v-for="item in businessList" :key="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>
    </a-tabs>
  </a-card>
</template>

<script>
import moment from 'moment'
import LineChart from './LineChart'
import PieChart from './PieChart'
import {
  queryEnablePics,
  getLineData,
  getPieData,
  getBusinessList,
} from '../api'

export default {
  name: 'ChartTabs',
  data() {
    const lastYear = moment().subtract(1, 'year')
    const dateRange = [lastYear, moment()]
    return {
      enableCreditTrends: false,
      enableTotalAr: false,
      activeKey: '1',
      businessList: [],
      enableCreditTrendsMy: false,
      startTime: '',
      endTime: '',
      enableCreditTrendsBu: false,
      enableTotalArBu: false,
      enableTotalArMy: false,
      dateRange,
      type: 1,
      businessId: '',
      lineChartData: null,
      pieChartData: null,
    }
  },
  mounted() {
    this._queryEnablePics()
    this._getBusinessList()
  },
  methods: {
    handleChangeBus(value) {
      this.businessId = value
      this.type = 3
      if (this.activeKey === '5') {
        console.log(this.dateRange)
        const [startTimeMoment, endTimeMoment] = this.dateRange
        this._getLineChartData(
          this.type,
          this.businessId,
          this.startTime
            ? this.startTime
            : startTimeMoment.format('YYYY-MM-DD'),
          this.endTime ? this.endTime : endTimeMoment.format('YYYY-MM-DD'),
        )
      } else {
        this._getPieChartData(this.type, this.businessId)
      }
    },
    _getBusinessList() {
      getBusinessList().then(({ data }) => {
        this.businessList = data
      })
    },
    _queryEnablePics() {
      queryEnablePics().then(({ data }) => {
        const {
          enableCreditTrends,
          enableTotalAr,
          enableCreditTrendsMy,
          enableCreditTrendsBu,
          enableTotalArBu,
          enableTotalArMy,
        } = data
        this.enableCreditTrends = enableCreditTrends
        this.enableCreditTrendsMy = enableCreditTrendsMy
        this.enableCreditTrendsBu = enableCreditTrendsBu
        this.enableTotalArBu = enableTotalArBu
        this.enableTotalArMy = enableTotalArMy
        this.enableTotalAr = enableTotalAr
        if (
          enableCreditTrends ||
          enableCreditTrendsBu ||
          enableCreditTrendsMy
        ) {
          const formatStr = 'YYYY-MM-DD'
          const [startTimeMoment, endTimeMoment] = this.dateRange
          this._getLineChartData(
            this.type,
            this.businessId,
            startTimeMoment.format(formatStr),
            endTimeMoment.format(formatStr),
          )
          this.activeKey = '1'
        }
        if (enableTotalAr || enableTotalArBu || enableTotalArMy) {
          this._getPieChartData(this.type, this.businessId)
          !enableCreditTrends && (this.activeKey = '2')
        }
      })
    },
    handleTabChange(newActivKey) {
      this.activeKey = newActivKey
      if (
        this.activeKey === '1' ||
        this.activeKey === '3' ||
        this.activeKey === '5'
      ) {
        if (this.activeKey === '1') {
          this.type = 1
        } else if (this.activeKey === '3') {
          this.type = 2
        } else {
          this.type = 3
        }
        const [startTimeMoment, endTimeMoment] = this.dateRange
        this._getLineChartData(
          this.type,
          this.businessId,
          this.startTime
            ? this.startTime
            : startTimeMoment.format('YYYY-MM-DD'),
          this.endTime ? this.endTime : endTimeMoment.format('YYYY-MM-DD'),
        )
      } else {
        if (this.activeKey === '2') {
          this.type = 1
        } else if (this.activeKey === '4') {
          this.type = 2
        } else {
          this.type = 3
        }
        this._getPieChartData(this.type, this.businessId)
      }
    },
    handleDateRangeChange(date, dateString) {
      const [startTime, endTime] = dateString
      this.startTime = startTime
      this.endTime = endTime
      // 重新渲染折线图
      this.lineChartData = null
      this._getLineChartData(this.type, this.businessId, startTime, endTime)
    },
    _getLineChartData(type, businessId, startTime, endTime) {
      getLineData({ type, businessId, startTime, endTime }).then(({ data }) => {
        this.lineChartData = data
      })
    },
    async _getPieChartData(type, businessId) {
      const params = {
        type: type,
        businessId: businessId,
      }
      const { data } = await getPieData(params)
      this.pieChartData = data
    },
  },
  components: { LineChart, PieChart },
}
</script>

<style></style>
